module.exports = __webpack_public_path__ + "static/media/microphone_wired.4dcedf1b.svg";